import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { breakpoints } from '~/theme';

export const Section = styled.section(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: `${theme.space[4]}`,
    marginBottom: `${theme.space[5]}`,
    paddingBottom: `${theme.space[5]}`,
    borderBottom: `1px solid ${theme.colors.grey50}`,

    [breakpoints.sm]: {
        marginBottom: `${theme.space[6]}`,
        paddingBottom: `${theme.space[6]}`,
    },
}));

export const List = styled.ul(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: `${theme.space[4]}`,

    [breakpoints.md]: {
        gridTemplateColumns: 'repeat(3, 1fr)',
    },
}));

// This is just an span used to animate on a nested text inside a link. Can only be used with multipleElements prop
export const StyledLinkAnimationText = styled.span<{ noContent?: boolean }>(
    ({ theme }) => ({
        fontSize: theme.fontSizes.guinea,
        letterSpacing: '-0.11px',
        lineHeight: theme.lineHeights.coyote,
        color: theme.colors.nightBlack,
        listStyle: 'none',
    }),

    ifProp('noContent', ({ theme }) => ({
        color: `${theme.colors.grey70}`,
        marginTop: `${theme.space[1]}`,
    })),
);
